import { createBrowserRouter } from "react-router-dom";
import MainPage from "../pages/MainPage";
import Usluga from "../pages/Usluga";

export const ERoutes = {
  MainPage: "/",
  Anything: "*",
};

const firstService = {
  title: "Procena rizika",
  firstQuestion: "Šta je procena rizika od katastrofa?",
  firstAnswer:
    "Procena rizika od katastrofa je najvažniji strateški dokument kojim se identifikuju opasnosti, određuje nivo rizika i na osnovu toga predlažu mere za ublažavanje, kako bi se uticaj na život i zdravlje ljudi, materijalna i kulturna dobra i životnu sredinu sveo na minimum.",
  secondQuestion: "Ko je u obavezi da izradi?",
  secondAnswer:
    "Republika, autonomna pokrajina, jedinice lokalne samouprave, privredna društva, zdravstvene ustanove, predškolske i školske ustanove, fakulteti, subjekti od posebnog značaja za zaštitu i spasavanje na svim nivoima, ustanove socijalne zaštite, privredna društva i javna preduzeća od posebnog značaja za privredu RS iz oblasti energetike, telekomunikacija, rudarstva i saobraćaja, pravna lica koja upravljaju poslovnim, trgovačkim, sportskim, ugostiteljskim, smeštajnim objektima i objektima za razonodu kapaciteta više od 100 lica, a u slučaju da su objekti namenjeni za boravak dece do 14 godina, nezavisno od kapaciteta.",
  thirdQuestion: "Za koji period se izrađuje?",
  thirdAnswer:
    "Procena rizika od katastrofa se periodično ažurira u skladu sa potrebama i novim okolnostima, u celini se ponovo izrađuje i donosi na svake tri godine, a ukoliko su se okolnosti u značajnoj meri promenile i ranije, odnosno ukoliko se pojavio novi rizik ili se postojeći rizik povećao ili smanjio.",
  img: "homepage1",
};

const secondService = {
  title: "Plan zaštite i spasavanja",
  firstQuestion: "Šta je plan zaštite i spasavanja?",
  firstAnswer:
    "Plan zaštite i spasavanja se izrađuje na osnovu procene rizika, a redovno se usklađuje sa izmenama procene rizika. Planom zaštite i spasavanja se planiraju mere i aktivnosti za sprečavanje i umanjenje posledica katastrofa, snage i sredstva subjekata sistema smanjenja rizika od katastrofa i upravljanje vanrednim situacijama, njihovo organizovano i koordinirano angažovanje i delovanje u vanrednim situacijama u cilju zaštite i spasavanja ljudi, materijalnih i kulturnih dobara i obezbeđenja osnovnih uslova za život.",
  secondQuestion: "Od čega se sastoji Plan zaštite i spasavanja?",
  secondAnswer:
    "Plan zaštite i spasavanja obavezno sadrži sledeće celine: rano upozoravanje i pripravnost (spremnost), mobilizacija i aktiviranje, zaštita i spasavanje po vrstama opasnosti, mere civilne zaštite, upotreba snaga i subjekata zaštite i spasavanja.",
  thirdQuestion: "Za koji period se izrađuje?",
  thirdAnswer:
    "S obzirom da proističe iz Procene rizika od katastrofa, plan se takođe periodično ažurira u skladu sa potrebama i novim okolnostima, dok se u celini ponovo izrađuje i donosi svake treće godine, a ukoliko se okolnosti u značajnoj meri promene i ranije, u skladu sa procenom rizika od katastrofa.",
  img: "homepage2",
};

const thirdService = {
  title: "Plan zaštite od udesa",
  firstQuestion: "Šta je plan zaštite od udesa?",
  firstAnswer:
    "Plan zaštite od udesa izrađuje se u skladu s važećim Zakonom o smanjenju rizika od katastrofa i upravljanju vanrednim situacijama (Sl. Glasnik RS br. 87/2018), Pravilnikom o vrstama i količinama opasnih materija, objektima i drugim kriterijumima.",
  secondQuestion: "Ko izrađuje plan?",
  secondAnswer:
    "Privredno društvo i drugo pravno lice (subjekti) koje obavlja aktivnosti u kojima je prisutna ili može biti prisutna jedna ili više opasnih supstanci u propisanim količinama, dužno je da preduzme sve neophodne mere za sprečavanje udesa i ograničavanje uticaja udesa na život i zdravlje ljudi, ekonomiju, ekologiju i društvenu stabilnost i životnu sredinu, u skladu sa zakonom.",
  thirdQuestion: "Na koji vremenski period?",
  thirdAnswer:
    "Subjekti su dužni da ažuriraju Plan zaštite od udesa prilikom organizacione promene, formiranja novog postrojenja ili izgradnje novog objekta, prilikom modifikacije postrojenja, promene količine, prirode i fizičkog oblika opasnih supstanci, promene postupka u načinu korišćenja opasnih supstanci ili druge promene koja može uticati na mogućnost nastanka udesa, i najkasnije tri meseca od nastale promene.",
  img: "homepage3",
};

export const router = createBrowserRouter([
  { path: ERoutes.MainPage, element: <MainPage /> },
  {
    path: "/procena-rizika-od-katastrofa",
    element: <Usluga service={firstService} />,
  },
  {
    path: "/plan-zastite-i-spasavanja",
    element: <Usluga service={secondService} />,
  },
  {
    path: "/plan-zastite-od-udesa",
    element: <Usluga service={thirdService} />,
  },
  { path: ERoutes.Anything, element: <MainPage /> },
]);
